module.exports = __webpack_public_path__ + "static/media/search-dark.cac6aa2f.svg";